
import React, { useState, useEffect, useRef } from 'react'
import { SketchPicker } from 'react-color';
import './ColorBox.scss';
import { useTheme } from '../../contexts/ThemeContext';
import copy from '../../assets/icons/copy.svg';
import copyDark from '../../assets/icons/copy-dark.svg';

const ColorBox = ({handleHex, defColour, index, edit, getInput}) => {
    const darkTheme = useTheme();
    const clipRef = useRef();
    const [lock, setLock] = useState(false)
    const darkShadow = {
        borderRadius: "50px",
        boxShadow: '35px 35px 70px #1d222a, -35px -35px 70px #272e38'
    }

   const copyToClip = (hex) => {
       navigator.clipboard.writeText(hex)
   }
    const componentToHex = (c) => {
        var hex = c.toString(16);
        return hex.length === 1 ? "0" + hex : hex;
      }
      
      const rgbToHex = (r, g, b) => {
        return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
      }

    const defHex = rgbToHex(defColour[0],defColour[1],defColour[2])

    const [showColorPicker, setShowColorPicker] = useState(false)
    const [hex, setHex] = useState(defHex)
    const [color, setColor] = useState({
        r: defColour[0],
        g: defColour[1],
        b: defColour[2],
        a: '1'
    })

    
    

    const handleClick = () => {
        setShowColorPicker(!showColorPicker)
    }

    const handleClose = () => {
        setShowColorPicker(false)
    }

    const handleChange = (color) => {
        setHex(color.hex)
        setColor(color.rgb)
        if (lock) {
            getInput([color.rgb.r,color.rgb.g,color.rgb.b], index);
        }
    }
    const handleLock = () => {
        if (!lock) {
            getInput([color.r, color.g, color.b], index)
        } else {
            getInput("N", index)
        }
        setLock(prev => !prev);
    }

    const handleCopy = (hex) => {
        copyToClip(hex)
        if(!edit) {
            const copy = clipRef.current
            copy.classList.toggle('show-copied')
            setTimeout(()=>{copy.classList.remove('show-copied')}, 1000)
            console.log(copy)
        }
        
    }
    useEffect(() => {
        handleHex(hex, index) 
    },[hex, index, handleHex])

    

    return (
        <div className={(edit) ? "colorbox-wrapper-edit" : "colorbox-wrapper"}>
            <div className={(edit) ? "colorbox-container-edit" : "colorbox-container"} onClick={handleClick}>
                <div className={(edit && darkTheme) ? "colorbox-color-edit-dark" : (edit) ? "colorbox-color-edit" : (darkTheme) ? "colorbox-color-dark" : "colorbox-color" } style={{background: `rgba(${color.r}, ${color.g},${color.b}, ${color.a})`}}/>
            </div>
            <div className="colorbox-tray">
                <div onClick={()=>{handleCopy(hex)}}className={(edit) ? "colorbox-hex-edit" : "colorbox-hex"}>{hex}</div>
                
                {(edit) ? null : <div className={(darkTheme) ? (lock) ? "colorbox-lock-active-dark" : "colorbox-lock-dark" : (lock) ? "colorbox-lock-active" : "colorbox-lock"} onClick={handleLock}></div>}
                {(showColorPicker) ? 
                (<div className="colorbox-open">
                    <div className="colorbox-close" onClick={handleClose}/>
                    <SketchPicker className="picker" color={color} onChange={handleChange} />
                </div>) : null }
            </div>
            {(edit) ? null : <p style={(darkTheme) ? darkShadow : null }ref={clipRef} className="copy">Copied To Clipboard<img className="clipboard" alt="clipboard Icon" src={(darkTheme) ? copyDark : copy}/></p>}
            
         </div> 
    )
}

export default ColorBox
